module.exports = __webpack_public_path__ + "img/Akute_Gefahr_durch_Mineralöl.45da4f5b.svg";